.fields mat-list-item{height:48px;width:100%;padding:0;background:#e5e4e2;margin:10px}
/*# sourceMappingURL=select-field-notebook-card.component-2EAQH6DU.css.map */
